import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
import GoogleTranslateWidget from '../../../../components/GoogleTranslateWidget';
export function BlogPostNarcissismGaslightingID() {
  const articleData = {
    title: 'Pelajari Tentang Istilah: Narsisme & Gaslighting',
    description: 'Bingung dengan perilaku narsistik atau gaslighting? Pelajari tanda-tanda utama dalam teks dan lihat bagaimana AI Toxic Detector langsung mengidentifikasi pola manipulasi halus.',
    slug: 'narcissism-gaslighting-explained',
    publishDate: '2025-07-15',
    author: 'Toxic Detector Editorial'
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: window.location.href
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Tautan disalin ke clipboard!');
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-6898" data-mp="3mecxid0r8cej">
      <GoogleTranslateWidget data-id="element-6899" data-mp="3hgl1b6t2u44j" />
      <Helmet data-id="element-6900" data-mp="3hgbefs3bwd32">
        <title data-id="element-6901" data-mp="3hjz60lp7qpf5">Narsisme & Gaslighting Dijelaskan | ToxicDetector</title>
        <meta name="description" content="Memahami psikologi di balik strategi manipulasi narsisme dan gaslighting." data-id="element-6902" data-mp="3dgkmhl22fqwy" />
        <meta name="keywords" content="narsisme, gaslighting, manipulasi, psikologi, analisis AI" data-id="element-6903" data-mp="1boeblx8yqxjt" />
        <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/iLMUMmEFFWiRSqv8DSTAdz/file_00000000f0c8720a9c4e7f9e2fbdea6d.png" data-id="element-6904" data-mp="16qmm19vsjnis" />
        <link rel="canonical" href={`https://toxicdetector.com/id/blog/${articleData.slug}`} data-id="element-6905" data-mp="1ulg923ec8fav" />
        <script type="application/ld+json" data-id="element-6906" data-mp="1gukxukgd9m44">
          {JSON.stringify(articleSchema)}
        </script>
      </Helmet>

      <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-6907" data-mp="1lt4fi8nxgbqo">
        <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-6908" data-mp="29ip5hbii099g">
          <div className="flex items-center justify-between" data-id="element-6909" data-mp="2dkalh5qbx3nv">
            <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-6910" data-mp="2dhod53vm6k4l">
              🚩 ToxicDetector
            </Link>
            <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Share article" data-id="element-6911" data-mp="24hj8v2lpw1un">
              <Share2 size={20} className="text-gray-600" data-id="element-6912" data-mp="t4qinw8krlgp" />
            </button>
          </div>
        </div>
      </header>

      <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-6913" data-mp="lmix7826o3qs">
        <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-6914" data-mp="gka3ualeezo5">
          <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-6915" data-mp="pm9jozkofxpi" />
          Kembali ke Blog
        </Link>

        <header className="mb-12" data-id="element-6916" data-mp="1uclwce2b67e">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-6917" data-mp="3u0rhztygrq8e">
            {articleData.title}
          </h1>
          <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-6918" data-mp="bnjpbrp8sc4u">
            <time dateTime={articleData.publishDate} data-id="element-6919" data-mp="6uqj0ze4kvqn">
              {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </time>
            <span className="text-gray-300" data-id="element-6920" data-mp="3nzhi27um4uul">•</span>
            <span data-id="element-6921" data-mp="3o0sji10l5qij">{articleData.author}</span>
          </div>
        </header>

        <div className="prose prose-lg max-w-none" data-id="element-6922" data-mp="3syu2kly0hpu0">
          <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-6923" data-mp="1rrcxyxtnrlw">
            Pernahkah Anda bertanya-tanya mengapa beberapa orang membuat Anda
            merasa bingung, lelah, atau meragukan diri sendiri dalam hubungan?
            Itu sering kali adalah <strong data-id="element-6924" data-mp="aj9r64b7jxcc">narsisme dan gaslighting</strong>{' '}
            yang sedang bekerja.
          </p>

          <section className="mb-12" data-id="element-6925" data-mp="fhkzgalutzsg">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6926" data-mp="ki91rsfja31z">
              Apa itu Narsisme?
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-6927" data-mp="phlpsgi55g65">
              <strong data-id="element-6928" data-mp="2m9lw5njvksjs">Narsisme</strong> adalah pola perilaku egois dan
              manipulatif di mana seseorang memprioritaskan kebutuhan mereka
              sendiri di atas orang lain.
            </p>
          </section>

          <section className="mb-12" data-id="element-6929" data-mp="18du8ayeel23z">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6930" data-mp="18evk5538tsmr">
              Apa itu Gaslighting?
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-6931" data-mp="zla8vvqaeti3">
              <strong data-id="element-6932" data-mp="zj63tagnjog8">Gaslighting</strong> adalah teknik manipulasi psikologis
              yang membuat Anda mempertanyakan realitas, ingatan, atau perasaan
              Anda sendiri.
            </p>
          </section>

          <section className="mb-12" data-id="element-6933" data-mp="1nav1z7g5n753">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6934" data-mp="1nbwdte4zvxnv">
              Bagaimana AI Kami Mendeteksi Pola Ini
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-6935" data-mp="1idl6ba269z8t">
              Alih-alih menebak, AI kami menganalisis percakapan Anda untuk pola
              manipulasi.
            </p>
          </section>

          <section className="mb-12" data-id="element-6936" data-mp="1xrykggz9jbz">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6937" data-mp="1wqmq9s50st7">
              Mengapa Memahami Ini Penting
            </h2>
            <p className="text-lg leading-relaxed text-gray-600" data-id="element-6938" data-mp="3cuorerbfsri">
              Mengenali <strong data-id="element-6939" data-mp="8cz77absaxkd">narsisme</strong> atau{' '}
              <strong data-id="element-6940" data-mp="3qjwq7pelu1fd">gaslighting</strong> sejak dini melindungi kesehatan
              emosional Anda.
            </p>
          </section>
        </div>

        <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-6941" data-mp="3vgn6acqesx0s">
          <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-6942" data-mp="3gs0rqd8lw9am">
            💀 Siap Melihat Kebenaran?
          </h2>
          <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-6943" data-mp="3lmdbkodzvmmw">
            Berhenti menebak. Unggah teks Anda ke Toxic Detector dan dapatkan
            skor toksisitas instan.
          </p>
          <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-6944" data-mp="2xupsutqvzhvp">
            Pindai Chat Anda Sekarang →
          </Link>
        </div>

        <div className="mt-16" data-id="element-6945" data-mp="2j8iyyf56sv9w">
          <RelatedBlogPosts posts={[{
          title: '7 Tanda Gaslighting',
          description: 'Pelajari pola gaslighting utama yang dideteksi AI dalam percakapan teks Anda.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: 'Apakah Mantan Anda Narsisis Tersembunyi?',
          description: 'Temukan apakah mantan Anda menunjukkan tanda-tanda perilaku narsistik tersembunyi melalui analisis teks.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }]} data-id="element-6946" data-mp="2j9u1kbmwbwzf" />
        </div>
      </article>

      <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-6947" data-mp="3kwuvmjcajc6s">
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-6948" data-mp="3gvrgjz22hk6m">
          <p className="text-gray-500 text-sm" data-id="element-6949" data-mp="3gxccnt415b6l">
            © {new Date().getFullYear()} ToxicDetector. Semua hak dilindungi.
          </p>
        </div>
      </footer>
    </div>;
}